<template>
  <el-dialog
    :visible="dialogVisible"
    title="发送设置"
    width="500px"
    @close="closeDialog"
    :close-on-click-modal="false"
  >
    <div class="section">
      <el-date-picker
        v-model="sendTime"
        type="datetime"
        placeholder="选择发送时间"
      >
      </el-date-picker>
    </div>
    <div class="section">
      <el-upload
        ref="upload"
        action=""
        :auto-upload="false"
        :show-file-list="false"
        :accept="acceptStr"
        :on-change="onFileChange"
      >
        <el-button slot="trigger" type="success" icon="el-icon-upload"
          >导入用户</el-button
        >
        <div slot="tip" class="el-upload__tip">
          选择上传{{ acceptStr }}文件。<br />
          格式： 第一列值为用户Id，该列第一行内容为标题“id”
        </div>
      </el-upload>
    </div>
    <div class="section">
      <el-card shadow="never" v-if="userIds.length">
        <div>
          <i class="el-icon-success"></i>成功导入<b> {{ userIds.length }} </b
          >条数据
          <el-button type="text" @click="showIdDetail = !showIdDetail">{{
            showIdDetail ? '收起' : '查看'
          }}</el-button>
        </div>
        <div v-if="showIdDetail" class="id-list">
          <div>
            {{ userIds.join(', ') }}
          </div>
        </div>
      </el-card>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        :disabled="!userIds.length && sendTime"
        :loading="uploading"
        type="primary"
        @click="submit"
        >发送短信</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import XLSX from 'xlsx';

export default {
  name: 'CreateSend',
  props: ['value'],
  data() {
    return {
      accept: ['xlsx', 'xls', 'csv'],
      dialogVisible: false,
      userIds: [],
      sendTime: null,
      showIdDetail: false,
      uploading: false
    };
  },
  computed: {
    acceptStr() {
      return this.accept.map(item => `.${item}`).join(', ');
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = !!val;
      this.userIds = [];
    }
  },
  methods: {
    submit() {
      const minute = 2;
      if (this.sendTime < new Date().getTime() + 1000 * 60 * minute) {
        this.$message.error(
          `为保证定时发送执行，请设置至少${minute}分钟之后的时间`
        );
      } else if (!this.userIds.length) {
        this.$message.error('请导入用户');
      } else {
        this.sendMessage({
          userIds: this.userIds,
          modelId: this.value.id,
          timestamp: this.sendTime
        }).then(() => {
          this.$messagee.success('定时设置成功');
          this.closeDialog();
        });
      }
    },
    onFileChange(file) {
      if (!file) return;
      const { raw: originFile } = file;
      const { name } = originFile;
      const suffix = name.split('.').pop();
      if (!this.accept.includes(suffix)) {
        this.$message.error(`只能上传${this.acceptStr}格式的文件`);
        return;
      }
      this.readDataFromFile(originFile);
    },
    readDataFromFile(file) {
      const that = this;
      const reader = new FileReader();

      reader.onload = e => {
        // pre-process data
        let binary = '';
        const bytes = new Uint8Array(e.target.result);
        const length = bytes.byteLength;
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }

        /* read workbook */
        const wb = XLSX.read(binary, {
          type: 'binary'
        });

        /* grab first sheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        /* generate HTML */
        const json = XLSX.utils.sheet_to_json(ws);
        that.userIds = json;
        try {
          that.userIds = json.map(item => item.id);
        } catch (e) {
          that.$message.error('文件解析错误');
        }
        that.uploading = false;
        /* update table */

        /* show export button */
      };
      reader.onerror = msg => {
        that.uploading = false;
        that.$message.error(msg);
      };
      this.uploading = true;
      reader.readAsArrayBuffer(file);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.uis = [];
      this.showIdDetail = false;
    }
  }
};
</script>

<style lang="less" scoped>
.section {
  margin-bottom: 10px;
}
.id-list {
  line-height: 18px;
  color: #666;
}
.el-icon-success {
  color: #67c23a;
  margin-right: 5px;
}
.el-upload__tip {
  display: inline-block;
  padding: 15px 0 0 10px;
}
</style>
